module.exports = __webpack_public_path__ + "media/assets/list_field-d06e70b80a0882b00e9919d4b8ac233e.svg";